import React from "react";
import { Link } from "react-router-dom";
import { Table, Space, Button, Popconfirm, message, Tag } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { ListComponent, BaseListComponentProps } from "../BaseComponent";
import { SearchRequest } from "../../services/api/interfaces/ApiRequest";
import { Pagination } from "components/Pagination";

type AnnouncementListProps = BaseListComponentProps & {
  announcements: any;
  pagination: any;
  loading: boolean;

  history: any;
  searchOptions: any;

  loadAnnouncements: (args: SearchRequest) => void;
  deleteAnnouncement: (args: any) => Promise<any>;
};

export default class AnnouncementList extends ListComponent<AnnouncementListProps> {
  static defaultProps = {
    loading: false,
  };

  tableColumns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a: any, b: any) => a.title - b.title,
    },
    {
      title: "Origin",
      dataIndex: "origin_key",
      key: "origin_key",
      sorter: (a: any, b: any) => a.origin_key - b.origin_key,
    },
    {
      title: "Link",
      dataIndex: "link",
      key: "link",
      sorter: (a: any, b: any) => a.link - b.link,
    },
    {
      title: "Is Active",
      dataIndex: "is_active",
      key: "is_active",
      sorter: (a: any, b: any) => a.is_active - b.is_active,
      render: (is_active: boolean) => is_active ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>,
    },
    {
      title: "Actions",
      key: "action",
      align: "right",
      render: (text: string, record: any) => (
        <Space size="middle">
          <Link
            to={`announcement/${record.uuid}`}
            ref={(refs) => this.actionRefs.edit.push(refs)}
          >
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>

          <div ref={(refs) => this.actionRefs.delete.push(refs)}>
            <Popconfirm
              title="Are you sure about turning off this announcement?"
              placement="topLeft"
              onConfirm={() => this.handleDelete(record.uuid)}
            >
              <Button type="dashed" shape="round" icon={<DeleteOutlined />} />
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ] as any;

  protected load() {
    this.searchOptions.search = {
      ...this.searchOptions.search,
      ...this.props.searchOptions.search,
    };

    this.props.loadAnnouncements(this.searchOptions);
  }

  handleDelete = async (uuid: string) => {
    const { deleteAnnouncement } = this.props;

    await deleteAnnouncement({
      uuid: uuid,
    });

    message.success("Announcement deleted successfully!");
  };

  render() {
    const { loading, pagination, announcements, loadAnnouncements } = this.props;

    return (
      <>
        <Table
          loading={loading}
          rowKey="uuid"
          columns={this.tableColumns}
          pagination={false}
          dataSource={announcements}
          onChange={(pagination: any, filters: any, sorter: any) =>
            this.handleTableChange(pagination, sorter, loadAnnouncements)
          }
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={announcements?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadAnnouncements)
          }
        />
      </>
    );
  }
}
